import { useFormStore } from '../stores/formStore'

/**
 * Composable per gestire il reset dello stato del form
 * @returns {Object} Oggetto con funzioni per resettare il form
 */
export function useFormReset() {
  const store = useFormStore()

  /**
   * Resetta completamente lo stato del form
   */
  const resetFormState = () => {
    store.selectedForm = null
    store.selectedPerson = null
    store.questions = []
    store.answers = {}
    store.customAnswers = {}
    store.errors = {}
    store.isFormSubmitted = false
    store.isSubmitted = false
  }

  /**
   * Resetta solo le risposte mantenendo form e persona selezionati
   */
  const resetAnswers = () => {
    store.answers = {}
    store.customAnswers = {}
    store.errors = {}
    store.isFormSubmitted = false
    store.isSubmitted = false
  }

  return {
    resetFormState,
    resetAnswers,
  }
}
